// extracted by mini-css-extract-plugin
module.exports = {"Players":"Players_Players__3MfxZ"};